export default __webpack_public_path__ + "./resource/fontawesome-webfont.1e59d2330b4c6deb84b340635ed36249.ttf";